import {JudgeResults} from "../services";
import {ListModel} from "./common";

import {LogEvent} from "@/types/test-calls";

export enum CallStatusModel {
  COMPLETED = "completed",
  HANGUP = "hangup_on_voicemail",
  BUSY = "busy",
  NO_ANSWER = "no-answer",
  FAILED = "failed",
  VOICEMAIL = "left_voicemail",
  IN_PROGRESS = "in-progress",
  CHECKING = "checking",
  PAUSED = "paused",
  QUEUE = "queue",
  INITIATED = "initiated",
}

export type CallRecordModel = {
  id: string;
  duration: number;
  labels?: string[];
  details: {
    id: string;
    status: CallStatusModel;
    campaignName: string;
    audio: string | null;
    startTime: number;
    leadName: string;
    leadPhoneNumber: string;
    agentPhoneNumber: string;
    endCallReason: string;
    error: string | null;
    telephony?: {
      hangup: string | null;
      disconnectReason: string | null;
      duration: number | null;
      start: string | null;
      end: string | null;
      callId: string | null;
    };
  };
  analysis: JudgeResults | null;
  transcript?: {
    senderType: string;
    title?: string;
    type: string;
    description?: string;
    date: string;
  }[];
  agent: {
    id: string;
    agentType: string;
  };
  actions?: {
    actionType: string;
    name: string;
    parametersHardCoded: object;
    parametersFromLlm: object;
    returnValue: object;
  }[];
  fsmLog?: {events: LogEvent[]};
};

export type CallListModel = ListModel<CallRecordModel>;

export enum CallFeedbackRatingEnum {
  AWFUL = "awful",
  GREAT = "great",
}
